module.exports = __webpack_public_path__ + "static/media/visa_electron.f273392b.svg";